import type { IModuleSliceHandle } from './IModuleSliceHandle';

const slices = new Map<string, IModuleSliceHandle>();

/**
 * Реєстр зрізів пакетів модулів: createModuleSlice реєструє зріз при створенні (тобто при лінивому імпорті state/<модуль>Slice через loadModule),
 * useRecordListModel знаходить його за ключем модуля, а підписник store персистує всі зареєстровані.
 */
export function registerModuleSlice(moduleKey: string, slice: IModuleSliceHandle): void {
  slices.set(moduleKey, slice);
}

export function findModuleSlice(moduleKey: string): IModuleSliceHandle | undefined {
  return slices.get(moduleKey);
}

export function registeredModuleSlices(): ReadonlyMap<string, IModuleSliceHandle> {
  return slices;
}
